import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CashRegisterUtilsService, CFSStatusInfo, ConnectionStatus, NetworkStatus } from "cfs-communication-pack";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-terminal-status",
  templateUrl: "./terminal-status.component.html",
  styleUrls: ["./terminal-status.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TerminalStatusComponent {
  constructor(private cashRegisterUtils: CashRegisterUtilsService) {}

  private _status?: ConnectionStatus;
  private _networkStatus?: NetworkStatus;

  statusInfo$ = new BehaviorSubject<CFSStatusInfo | null>(null);

  @Input() set status(status: ConnectionStatus) {
    this._status = status;

    this.updateStatusInfo();
  }

  @Input() set networkStatus(networkStatus: NetworkStatus) {
    this._networkStatus = networkStatus;

    this.updateStatusInfo();
  }

  private updateStatusInfo(): void {
    if (this._networkStatus || this._status === ConnectionStatus.UNAVAILABLE) {
      const statusInfo = this.cashRegisterUtils.getCashregisterStatusLabel(this._status, this._networkStatus);

      this.statusInfo$.next(statusInfo);
    }
  }
}
